import type { Database } from "@shared/database.types";
import { formatPhone, formatTimestamp } from "../../lib";
import type { Tag } from "../_shared";

type NotificationEvent = Database["public"]["Enums"]["notification_event"];
type NotificationChannel = Database["public"]["Enums"]["notification_channel"];

export type NotificationPreferences = Partial<
  Record<NotificationEvent, Partial<Record<NotificationChannel, boolean>>>
>;

export type UserRow = Omit<
  Database["public"]["Views"]["v_users_list"]["Row"],
  "schools" | "notification_preferences"
> & {
  schools: Tag[] | null;
  notification_preferences: NotificationPreferences | null;
};

export const usersListSortMap: Record<string, string> = {
  first_name: "first_name",
  last_name: "last_name",
  full_name: "full_name",
  email: "email",
  created_at: "created_at",
  updated_at: "updated_at",
};

export const usersSearchCols = ["full_name", "email"];

export const roleLabels: Record<
  Database["public"]["Enums"]["user_role"],
  string
> = {
  superuser: "Super User",
  school_admin: "School Admin",
  substitute: "Substitute",
};

export function decorateUser(user: UserRow) {
  const schools = user.schools ?? [];
  return {
    ...user,
    f_phone: formatPhone(user.phone),
    f_schools: schools.map((s) => s.label).join(", "),
    f_role: user.role ? roleLabels[user.role] ?? user.role : null,
    f_created_at: formatTimestamp(user.created_at),
    f_updated_at: formatTimestamp(user.updated_at),
    f_deleted_at: formatTimestamp(user.deleted_at),
  };
}
